export const MAX_CLIPBOARD_IMAGE_BYTES = 5 * 1024 * 1024;

const SUPPORTED_CLIPBOARD_IMAGE_TYPES = new Set([
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/webp',
]);

export function clipboardImageError(file: Blob): string | null {
  if (!SUPPORTED_CLIPBOARD_IMAGE_TYPES.has(file.type)) {
    return 'Clipboard images must be PNG, JPEG, WebP, or GIF.';
  }
  if (file.size > MAX_CLIPBOARD_IMAGE_BYTES) {
    return 'Clipboard images must not exceed 5 MB.';
  }
  return null;
}
